export default __webpack_public_path__ + "238dc9f97d7d8692b94a4de6cb3a4ab7.png";